export default __webpack_public_path__ + "static/media/D200MAND4.16846e83.pdf";